import {Controller} from "@hotwired/stimulus";

// Beschränkt eine Liste von <label>-Elementen auf eine bestimmte Anzahl
// sichtbarer Einträge (visibleValue).
// Umschaltbar per Link "alle anzeigen" / "weniger ausblenden"
//
// Bereits ausgewählte Checkboxen werden NIE ausgeblendet
// (Begründung: FormValues im "eingeklappten Block" werden
// übertragen, obwohl die Benutzerin sie nicht mehr sehen würde.)
//
// Erwartete Attribute / Elemente:
//   data-controller="expandable-list"
//   data-expandable-list-visible-value="5"
//   data-expandable-list-expanded-value="false"
//   data-expandable-list-more-label-value="..."
//   data-expandable-list-less-label-value="..."
//   data-action="change->expandable-list#refresh"
//   ein Element mit data-expandable-list-target="toggle"
export default class extends Controller {
  static targets = ["toggle"]

  static values = {
    visible: Number,
    expanded: Boolean,
    moreLabel: String,
    lessLabel: String
  }

  get items() {
    return Array.from(this.element.querySelectorAll(":scope label"))
  }

  connect() {
    this.render()
  }

  toggle(event) {
    event.preventDefault()
    this.expandedValue = !this.expandedValue
  }

  expandedValueChanged() {
    this.render()
  }

  // wird bei jedem change-Event im Block aufgerufen
  refresh() {
    this.render()
  }

  render() {
    this.items.forEach((label, index) => {
      const checkbox = label.querySelector("input[type='checkbox']")

      const keepVisible =
        this.expandedValue ||
        index < this.visibleValue ||
        (checkbox && checkbox.checked)

      label.classList.toggle("hide", !keepVisible)
    })

    if (this.hasToggleTarget) {
      this.toggleTarget.textContent =
        this.expandedValue ? this.lessLabelValue : this.moreLabelValue
    }
  }
}
